module.exports = __webpack_public_path__ + "media/images/diy/testimonial_sharon-9062ddf3df6161fc6d0d3af3de6e61bf.jpg";